import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { setTheme } from '../store';

export function useThemeLoader() {
  const dispatch = useDispatch();

  const { data } = useQuery({
    queryKey: ['theme'],
    queryFn: () => api.getTheme().then(r => r.data),
    staleTime: 1000 * 60 * 10,
  });

  useEffect(() => {
    if (data) dispatch(setTheme(data));
  }, [data, dispatch]);
}
